/**
 * Use this list to disable problematic events. Events can also be disabled
 * through ECS but they will still be sent during OOBE or before we load application settings.
 */
const disabledEvents = new Set<string>();
disabledEvents.add('ConvertIdsToTargetFormat'); // Disabled 2026-04-29. Logging 1.5+ billion rows per day despite being sampled
disabledEvents.add('GetTokenApi'); // WI: 214597. Reason: Caused spikes every 15 minutes in Aria client_event table.
disabledEvents.add('GetTokenApiUsingHostApp_MacOutlook'); // WI: 214597. Reason: Caused spikes every 15 minutes in Aria client_event table.
disabledEvents.add('GetTokenApiUsingHostApp_Native'); // WI: 214597. Reason: Caused spikes every 15 minutes in Aria client_event table.
disabledEvents.add('GetTokenApiUsingHostApp_OutlookDesktop'); // WI: 214597. Reason: Caused spikes every 15 minutes in Aria client_event table.
disabledEvents.add('GetTokenApiUsingHostApp_Teams'); // WI: 214597. Reason: Caused spikes every 15 minutes in Aria client_event table.
// GetTokenApiUsingMSAL: Checking Volume after implementing sessionSampleRate: 2 (targeting ~70M/day down from 3B+)
disabledEvents.add('ImmutableIdConversion'); // Disabled 2026-04-29. Logging 1.5+ billion rows per day despite being sampled
disabledEvents.add('SwImages'); //Disabled in ECS due to throttling Oct 15, 2024
disabledEvents.add('TrouterInfo'); //Disabled in ECS due to throttling Oct 19, 2025

// MailboxInfo Compliance Enforcement — disabled 2026-05-08 per Outlook Ninja Lite MailboxInfo
// Compliance Tracker. These datapoints did not have MailboxInfo wired up by the May 1, 2026
// deadline, so they are being turned off to prevent emitting telemetry that cannot be correctly
// attributed to a mailbox/account in multi-account scenarios. Owners can re-enable an event by
// removing it from this list once MailboxInfo is plumbed through to the call site. Final cutoff
// for code removal is Aug 15, 2026.
// From file: shared/internal/owa-analytics-events/src/data-catalog/calendarEvents.ts
disabledEvents.add('mailboxTimeZoneChanged');
disabledEvents.add('RSVP_Suggestions_Action_Suggested');
disabledEvents.add('CalendarOnlineMeetingCaching_Cache_Error');
disabledEvents.add('CalendarOnlineMeetingCaching_Cache_Fill');
disabledEvents.add('CalendarOnlineMeetingCaching_Cache_Hit');
disabledEvents.add('CalendarOnlineMeetingCaching_Cache_Miss');
disabledEvents.add('CreateCalendarEvent_MissingParentFolderId');
disabledEvents.add('dismissTimeZoneTravelDialog');
disabledEvents.add('GetItemIdToUpdate_CalendarEventSeriesMasterItemIdNotInCache');
disabledEvents.add('osTimeZoneFound');
disabledEvents.add('UpdateCalendarEvent_InstantCalendarEventUpdateThrownError');
disabledEvents.add('UpdateCalendarEvent_InstantCalendarEventUpdateUnsuccessfulResult');
disabledEvents.add('ExportCurateData');
disabledEvents.add('JoinWithAnId_JoinMeeting');
// TrouterInfo already disabled above
disabledEvents.add('CalendarEvent_SubmitProcessor_DeleteCancelActionFoundWithSubsequentActions');
disabledEvents.add('CalendarEvent_SubmitProcessor_UnexpectedActionTypeInDependentActions');
disabledEvents.add('BackroomChatButtonClicked');
// From file: shared/internal/owa-analytics-events/src/data-catalog/partnerIntegrationEvents.ts
disabledEvents.add('MeetingAppTab_getTabsWithEntitlements');
disabledEvents.add('AppBarPinnedApps_InvalidState');
disabledEvents.add('MosAppServiceNotSupported');
disabledEvents.add('TEAMS_DELETE_SELECTED_CHANNEL');
disabledEvents.add('TEAMS_DELETE_SELECTED_CHANNEL_FAILED');
disabledEvents.add('TEAMS_GET_SELECTED_CHANNELS');
disabledEvents.add('TEAMS_GET_SELECTED_CHANNELS_FAILED');
disabledEvents.add('TEAMS_SAVE_SELECTED_CHANNEL');
disabledEvents.add('TEAMS_SAVE_SELECTED_CHANNEL_FAILED');
// From file: shared/internal/owa-analytics-events/src/data-catalog/addinEvents.ts
disabledEvents.add('ExtContextualHighlightTime');
disabledEvents.add('ExtGDPRMinorDialogResponse');
disabledEvents.add('Extensibility');
disabledEvents.add('UILessFrame_AddinIframe_OrphanedDetected');
// From file: shared/internal/owa-analytics-events/src/data-catalog/timeCollabEvents.ts
disabledEvents.add('CollabServiceDP');
disabledEvents.add('commitMeetingNotes');
disabledEvents.add('CreateCollabSpaceTime');
disabledEvents.add('LoadCollabSpaceTime');
disabledEvents.add('NotesResourceCreationFailed');
// From file: shared/internal/owa-analytics-events/src/data-catalog/meetingRecapEvents.ts
disabledEvents.add('IntelligentRecapDeepLinkPeekViewClicked');
// From file: shared/internal/owa-analytics-events/src/data-catalog/presenceEvents.ts
disabledEvents.add('fetchMRIs');
disabledEvents.add('GetMRI');
disabledEvents.add('OnPresenceServiceError');
disabledEvents.add('PresenceGetMrisFromGraphInBulk');
disabledEvents.add('PresenceService_FetchError');
// From file: shared/internal/owa-analytics-events/src/data-catalog/calendarTriageAndPlansEvents.ts
disabledEvents.add('ScheduleFromMail');
// From file: shared/internal/owa-analytics-events/src/data-catalog/schedulingEvents.ts
disabledEvents.add('addToMyCalendar');
disabledEvents.add('MeetingOptionsDialogMetaOsRingFetch');
// From file: shared/internal/owa-analytics-events/src/data-catalog/timePlacesEvents.ts
disabledEvents.add('protocolActivation-file-ics-import-failed');
disabledEvents.add('protocolActivation-file-ics-import-success');
disabledEvents.add('protocolActivation-file-ics-importClicked');
disabledEvents.add('RespondToCalendarEventService_EventIdIsNotAnItemId');
disabledEvents.add('Search_RefinerClicked');
disabledEvents.add('toggleTimeZoneTravelNotificationIsDisabled');
disabledEvents.add('UpdateSubjectForInPersonMeeting_EndsWithIsNotAFunction');
disabledEvents.add('Update_ItemIdIsNotAnItemId');
// From file: shared/internal/owa-analytics-events/src/data-catalog/toDoEvents.ts
disabledEvents.add('CreateTaskServiceEmptyRequest');
disabledEvents.add('TodoAction');
disabledEvents.add('TodoItemActionCreate');
disabledEvents.add('TodoItemActionViewEmail');
disabledEvents.add('todoMetaDataCompletedTask');
disabledEvents.add('todoMetaDataTasks');
disabledEvents.add('TodoPanelActionChangeFolder');
disabledEvents.add('TodoPanelActionHideRecentlyCompleted');
disabledEvents.add('TodoPanelActionShowRecentlyCompleted');
disabledEvents.add('todoPanelManageAllTasks');
disabledEvents.add('todoPerformanceFolderSwitch');
// From file: shared/internal/owa-analytics-events/src/data-catalog/growthEvents.ts
disabledEvents.add('AnbDateFormatError');
disabledEvents.add('ANB_InvalidSubscription_Init');
disabledEvents.add('ANB_NoSubscription_Init');
disabledEvents.add('ANB_ValidSubscription_Init');
// From file: shared/internal/owa-analytics-events/src/data-catalog/diagnosticsEvents.ts
disabledEvents.add('DiagnosticsAndSupport_completeODSFeedbackSession');
disabledEvents.add('DiagnosticsAndSupport_createODSFeedbackSession');
disabledEvents.add('MetaOS_ODSLogging_SendLogsFailed');
// From file: shared/internal/owa-analytics-events/src/data-catalog/nativeHostEvents.ts
disabledEvents.add('dismissRestoreItemsDialog');
// From file: shared/internal/owa-analytics-events/src/data-catalog/authoringEvents.ts
disabledEvents.add('CLPLabelLearnMoreClicked');
// From file: shared/internal/owa-analytics-events/src/data-catalog/smimeEvents.ts
disabledEvents.add('InitializeSmimeAdapter');
disabledEvents.add('SmimeBrowserNotSupportedDatapoint');
disabledEvents.add('SmimeControlDownloadDatapoint');
disabledEvents.add('SmimeExtensionInitializationFailedDatapoint');
disabledEvents.add('SmimeMissingExtensionDatapoint');
disabledEvents.add('SmimeTraceError_IsConsumer');
// From file: shared/internal/owa-analytics-events/src/data-catalog/personaEvents.ts
disabledEvents.add('ContactManagement_GetContactUnificationStatus');
disabledEvents.add('ContactManagement_SetHasSeenByUserValue');
// From file: shared/internal/owa-analytics-events/src/data-catalog/authenticationAndIdentityEvents.ts
disabledEvents.add('GetAuthenticationUrl');
// From file: shared/internal/owa-analytics-events/src/data-catalog/acceleratorEvents.ts
disabledEvents.add('updateCurrentEventThemeImageAction');
disabledEvents.add('updateFREState');

/**
 * Use this list to allow events that are core events.
 * NOT CURRENTLY USED BUT WILL SOON.
 */
const allowedIsCoreEvents = new Set<string>();

export function isEventDisabled(eventName: string): boolean {
    return disabledEvents.has(eventName);
}

export function isCoreEventAllowed(eventName: string): boolean {
    return allowedIsCoreEvents.has(eventName);
}
